module.exports = __webpack_public_path__ + "static/media/10d.aeb50232.png";